import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const CTA00Table: GenericTableSchemaInterface = {
  id: "cta-00",
  name: "CTA 00",
  description: "This table contains data regarding how many people engage with the CTA on mobile v desktop.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Desktop Start"
    },
    c04: {
      name: "Mobile Start"
    }
  }
};
